export default __webpack_public_path__ + "static/media/logo-design.acc77053.svg";